import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ic_close.svg'


const _withScopeId = n => (_pushScopeId("data-v-5ac5ab95"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = {
  class: "modal2",
  style: {"width":"900px"}
}
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-center flex-1 modal-header-title"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center flex-1 modal-header-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_9 = { class: "table table-borderless" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*标题:")
  ])
], -1))
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { style: {"line-height":"36px"} }, "*答案:")
  ])
], -1))
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "状态:")
  ])
], -1))
const _hoisted_16 = { class: "mb-1 form-switch" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*排序:")
], -1))
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = { class: "flex-row-center modal-footer2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RichEditor = _resolveComponent("RichEditor")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.itemData.data.id != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "修改"))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "增加")),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.data.title) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.itemData.data.title]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_RichEditor, {
                      modelValue: _ctx.itemData.data.content,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemData.data.content) = $event)),
                      "min-height": 200
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      checked: "",
                      type: "checkbox",
                      role: "switch",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemData.data.show) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.itemData.data.show]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemData.data.sort) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.itemData.data.sort]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}